import translate from '@/services/contact/translatorContact';

export default function validation(response,
  messages, i18n) {
  if (response === 'Contact_AddForbiddenLinkedToTiers') {
    messages.push({
      message: 'editionContact.messages.errorTiersNotExiste',
    });
  }

  if (response.data.error.validationErrors !== null) {
    response.data.error.validationErrors.forEach((error) => {
      let champs = '';
      if (error.members) {
        champs = translate(error.members[0], i18n);
        messages.push({
          message: champs,
        });
      }
      if (error?.message?.indexOf('TIERS_NOT_PARENT') !== -1) {
        messages.push({
          message: 'editionContact.messages.errorNotParent',
        });
      }

      if (error?.message?.indexOf('Error converting value {null}') !== -1) {
        messages.push({
          message: 'editionContact.messages.errorTiersNotExiste',
          parametres: {
            name: champs,
          },
        });
      }
    });
  }
}
